/* dev/assets/js/a-video.js */
(function ($) {
    "use strict";
    $(function () {

        if ($('.js-template-promo').length) {
            $('.promo-youtube-player').on('click', function () {
                $(this).html(`<iframe src="https://www.youtube.com/embed/${$(this).data('id')}?autoplay=1&amp;rel=0&amp;enablejsapi=1" frameborder="0" allow="autoplay" allowfullscreen="1"></iframe>`);
            });
        }

    });
})(jQuery);
